goog.provide('el8.app.settings.staffDisplaySettings');

goog.require('el8.app.settings.util');
goog.require('el8.data.decisionSupports');
goog.require('el8.service.urls');
goog.require('el8.template.app.settings.sections');
goog.require('el8.uiwidget.Form');
goog.require('el8.util.consts');


el8.app.settings.staffDisplaySettings = (function() {

    var that = {};
    var $container;

    that = {

        init: function(_container) {

            $container = _container;

            el8.data.decisionSupports.load();
            var decisionSupports = _.reject(el8.data.decisionSupports.allAsSoyMaps(), function(ds) {
                // Remove the ones that are not configurable
                return !ds.isConfigurable;
            });

            var $content = $(el8.template.app.settings.sections.staffDisplaySettings({
                decisionSupports: decisionSupports,
                isPracticeAdmin: el8.data.currUser.isPracticeAdmin()
            }));
            $container.html($content).show();

            var form = createForm();
            form.render();
            populateForm(form);

            bindTriggers($content, form);
        }
    };

    function createForm() {
        /* We're using the same field names here as in appPrefs,
         * even though the backend field names are not the same,
         * so we can share the same template and because we're not
         * relying on form.getMapped anyways */
        var fields = [];
        fields.push({
            name: 'cdsEnabled',
            selector: ':input[name="cdsEnabled"]',
            castToBool: true
        });
        fields.push({
            name: 'cdsDisplaySupDiag',
            selector: ':input[name="cdsDisplaySupDiag"]',
            castToBool: true
        });
        el8.data.decisionSupports.all().forEach(function(cds) {
            var name = _getIndividualCdsFormName(cds);
            fields.push({
                name: name,
                selector: ':input[name="'+name+'"]',
                castToBool: true
            });
        });
        fields.push({
            name: 'passportNoticeInVisitSummaries',
            selector: ':input[name="passportNoticeInVisitSummaries"]',
            castToBool: true
        });
        fields.push({
            name: 'hccScoring',
            selector: ':input[name="hccScoring"]',
            castToBool: true
        });

        return new el8.uiwidget.Form({
            container: $('form', $container),
            fields: fields
        });
    }

    function populateForm(form) {
        form.populate({
            'cdsEnabled': el8.data.practiceSettings.isStaffCdsEnabled(),
            'cdsDisplaySupDiag': el8.data.practiceSettings.isStaffCdsDisplaySupDiag(),
            'passportNoticeInVisitSummaries': el8.data.practiceSettings.isPassportNoticeInVisitSummaries(),
            'hccScoring': el8.data.practiceSettings.isHccScoringEnabled()
        }, true);

        populateIndividualCdsSettings(form);
        if (el8.data.practiceSettings.isStaffCdsEnabled()) {
            $('.individual-cds-items', $container).show();
        } else {
            $('.individual-cds-items', $container).hide();
        }
    }

    function populateIndividualCdsSettings(form) {
        el8.data.decisionSupports.all().forEach(function(cds) {
            var name = _getIndividualCdsFormName(cds);
            var isMeasureEnabled = el8.data.practiceSettings.isStaffSupportEnabled(cds.getNqfCode());
            form.setVal(name, isMeasureEnabled, true);
        });
    }

    function bindTriggers($content, form) {
        $content.on('change', ':input[name="cdsEnabled"]',  function(event) {
            var elt = $(this);

            var isEnabled = form.getVal('cdsEnabled');
            var callbackFn = function() {
                el8.data.practiceSettings.updateStaffCdsEnabled(isEnabled, function() {
                    el8.app.settings.util.handleSavedMsg(elt.parent().parent().parent());
                });
            };

            if (form.getVal('cdsEnabled')) {
                var enableMeasures = [];
                $(':input.individual-cds-input').each(function() {
                    var elt = $(this);
                    var cds = el8.data.decisionSupports.getById(elt.data('id'));
                    enableMeasures.push(cds.getNqfCode());
                });

                el8.data.practiceSettings.updateStaffSupports(enableMeasures, function() {
                    populateIndividualCdsSettings(form);
                    $('.individual-cds-items').show();

                    callbackFn();
                });

            } else {
                $('.individual-cds-items').hide();
                callbackFn();
            }

        }).on('change', ':input[name="cdsDisplaySupDiag"]',  function(event) {
            var elt = $(this);
            var callbackFn = function() {
                el8.app.settings.util.handleSavedMsg(elt.parent().parent().parent());
            };
            var isEnabled = form.getVal('cdsDisplaySupDiag');
            el8.data.practiceSettings.updateStaffCdsDisplaySupDiag(isEnabled, callbackFn);

        // Covers all individual cds items
        }).on('change', ':input.individual-cds-input',  function(event) {
            var $elt = $(this);
            var cds = el8.data.decisionSupports.getById($elt.data('id'));
            var name = _getIndividualCdsFormName(cds);
            var isEnabled = form.getVal(name);

            // Quick fix: disable all cds inputs until a call is successful
            $(':input.individual-cds-input').each(function() {
                    var elt = $(this);
                    elt.prop('disabled', true);
                });

            var callbackFn = function() {
                el8.app.settings.util.handleSavedMsg($elt.parent().parent().parent());
                // Enable inputs again after success
                $(':input.individual-cds-input').each(function() {
                    var elt = $(this);
                    elt.prop('disabled', false);
                });
            };
            if (isEnabled) {
                el8.data.practiceSettings.enableStaffSupport(cds.getNqfCode(), callbackFn);
            } else {
                el8.data.practiceSettings.disableStaffSupport(cds.getNqfCode(), callbackFn);
            }

        }).on('change', ':input[name="passportNoticeInVisitSummaries"]',  function() {
            var $elt = $(this);
            var isEnabled = form.getVal('passportNoticeInVisitSummaries');
            el8.data.practiceSettings.updatePassportNoticeInVisitSummaries(isEnabled, function() {
                el8.app.settings.util.handleSavedMsg($elt);
            });

        }).on('change', ':input[name="hccScoring"]',  function() {
            var $elt = $(this);
            var isEnabled = form.getVal('hccScoring');
            el8.data.practiceSettings.updateHccScoringEnabled(isEnabled, function() {
                el8.app.settings.util.handleSavedMsg($elt);
            });
        });
    }

    function _getIndividualCdsFormName(cds) {
        return cds.getNqfCode();
    }


    return that;

})();
